import React, { useContext, useEffect, useState } from 'react';
import PaymentSettingsLink from '../components/paymentSettings/PaymentSettingsLink';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import SideLeft from '../layout/SideLeft';
import AppContext from '../Context/AppContext';
import SideMinTalk from '../layout/SideMinTalk';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import CenterTalk from '../components/CenterTalk';
import StatProjects from '../components/StatProjects';
import { useParams, useLocation } from "react-router-dom";
import CenterTalkSearch from '../components/CenterTalkSearch';


const MessageUserSport = () => {
    const [selectTalk, setSelectTalk] = useState()
    const [searchTalk, setSearchTalk] = useState()
    const { setCurrentPage } = useContext(AppContext)
    const [iMessages, setImessages] = useState(null)
    const [userOnline, setUserOnline] = useState([])
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const { id } = useParams();
    const location = useLocation()
    const { socketSport, setMessageUserSport } = useSocket()
    const userToken = infoUser()



    const fetchImessage = (p = 1) => {
        socketSport.emit('empire_tracker_all_message', { token: userToken.expecttoken, page: p }, (e) => {
            setMessageUserSport(false)
            const arr = Array.isArray(e) ? e : (e?.data || [])
            setTotalPage(Array.isArray(e) ? 1 : (e?.total_page || 1))
            setPage(Array.isArray(e) ? 1 : (e?.current_page || 1))
            setImessages(prev => (p > 1 && prev) ? [...prev, ...arr] : arr)
        })
    }
    const loadMore = () => {
        if (page < totalPage) fetchImessage(page + 1)
    }
    const initMessage = () => {
        if (socketSport) {
            fetchImessage()

        }
    }
    const initUserOnline = () => {
        if (socketSport) {
            socketSport.emit('empire_get_user_online', { token: userToken.expecttoken }, (e) => {
                setUserOnline(e)
            })
            socketSport.on('notif_get_user_onine', (e) => {
                setUserOnline(e)
            })
        }
    }


    useEffect(() => {
        if (socketSport) {
            initMessage()
            initUserOnline()
            setCurrentPage('message_user_sport')
            socketSport.on('notif_admin', (e) => {
                fetchImessage()
            })
        }
    }, [socketSport])

    useEffect(() => {
        const search = location.state?.search
        if (socketSport && search) {
            socketSport.emit('empire_search_user_talk', { token: userToken.expecttoken, search }, (e) => {
                setSearchTalk(e)
            })
        }
    }, [socketSport, location.state])

    /*useEffect(() => {
        if (id && iMessages?.length > 0) {
            const findMessageAlready = iMessages.find(el => el.user.id == id);
            if (findMessageAlready) {
                setSelectTalk(findMessageAlready)
            }
        }
    }, [id, iMessages])*/


    return (
        <MainLayout addClass={(selectTalk && !searchTalk) ? 'talk-open' : ''}>
            <SideMinTalk
                iMessages={iMessages}
                userOnline={userOnline}
                currentPage={page}
                totalPage={totalPage}
                onLoadMore={loadMore}
                onSearch={(e) => {
                    setSearchTalk(e)
                }}
                onSelect={(e) => {
                    console.log(e);

                    setSelectTalk(e)
                    setSearchTalk(null)
                }}
                label='Discutions Sport'
            >

            </SideMinTalk>
            <CenterLayout>
                
                 {searchTalk && (
                     <CenterTalkSearch result={searchTalk} selectConversation={v => {
                         const findMessage = iMessages.find(el => el.user.id == v.user_id)
                         console.log(findMessage);
                         
                         if (findMessage) {
                             setSelectTalk(findMessage)
                             setSearchTalk(null)
                         } else {
                             console.log(v);
 
                             const newUser = { last_message_date: null, messages: [], user: { email: v.email, id: v.user_id, isOnline: [], path: v.path, slug: v.firstname + " " + v.lastname } }
                             setImessages(prev => [...prev, newUser])
                             setSelectTalk(newUser)
                             setSearchTalk(null)
                         }
                     }} />
                 )}
                
                {!searchTalk && selectTalk && iMessages && (
                    <CenterTalk el={selectTalk} iMessages={iMessages} init={fetchImessage} type='sport' onBack={() => setSelectTalk(null)} />
                )}
            </CenterLayout>

            <SideLeft>
                <StatProjects open={(cmp) => { }} />
                <p className='fm cw mb1 fs20'>Paramettre</p>
                <PaymentSettingsLink />
            </SideLeft>
        </MainLayout>

    );
};

export default MessageUserSport;